import TextElement from './TextElement.vue';
import TextButtonElement from './TextButtonElement.vue';
import ImageElement from './ImageElement.vue';
import DocumentElement from './DocumentElement.vue';
import ListElement from './ListElement.vue';
import AudioElement from './AudioElement.vue';
import AudioWolofElement from './AudioWolofElement.vue';
import VideoElement from './VideoElement.vue';
import DelayElement from './DelayElement.vue';
import RequestElement from './RequestElement.vue';
import AnswerElement from './AnswerElement.vue';
import RedirectElement from './RedirectElement.vue';
import NotificationElement from './NotificationElement.vue';
import VariableInsertElement from './VariableInsertElement.vue';
import LocationRequestElement from './LocationRequestElement.vue';
import ButtonLinkElement from './ButtonLinkElement.vue';
import TemplateElement from './TemplateElement.vue';
import AgentHandoffElement from './AgentHandoffElement.vue';
import ConditionElement from './ConditionElement.vue';
import AskForPaymentElement from './AskForPaymentElement.vue';
import ActionElement from './ActionElement.vue';

export {
  TextElement,
  TextButtonElement,
  ImageElement,
  DocumentElement,
  ListElement,
  AudioElement,
  AudioWolofElement,
  VideoElement,
  DelayElement,
  RequestElement,
  AnswerElement,
  RedirectElement,
  NotificationElement,
  VariableInsertElement,
  LocationRequestElement,
  ButtonLinkElement,
  TemplateElement,
  AgentHandoffElement,
  ConditionElement,
  AskForPaymentElement,
  ActionElement
};

// Mapping des types d'éléments aux composants
export const ELEMENT_COMPONENTS = {
  text: TextElement,
  text_button: TextButtonElement,
  text_buttons: TextButtonElement, // Ajout d'une variante avec 's' pour compatibilité
  interactive_buttons: TextButtonElement, // Autre variante possible
  buttons: TextButtonElement, // Autre variante possible
  image: ImageElement,
  document: DocumentElement,
  list: ListElement,
  audio: AudioElement,
  audio_wolof: AudioWolofElement,
  video: VideoElement,
  delay: DelayElement,
  request: RequestElement,
  answer: AnswerElement,
  redirection: RedirectElement,
  notification: NotificationElement,
  variable_insert: VariableInsertElement,
  location_request_message: LocationRequestElement,
  button_link: ButtonLinkElement,
  template_message: TemplateElement,
  agent_handoff: AgentHandoffElement,
  condition: ConditionElement,
  ask_payment: AskForPaymentElement,
  action: ActionElement
};

export default ELEMENT_COMPONENTS;
